import { render, staticRenderFns } from "./FuncionalidadeBtn.vue?vue&type=template&id=d0f86e08&scoped=true"
import script from "./FuncionalidadeBtn.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeBtn.vue?vue&type=script&lang=js"
import style0 from "./FuncionalidadeBtn.vue?vue&type=style&index=0&id=d0f86e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f86e08",
  null
  
)

export default component.exports